import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { addDatapointConfig } from 'owa-analytics-actions';
import { action } from 'satcheljs';

/**
 * action invoked when user clicks on Share button
 *
 * @param surfaceStore the surface store
 */
export const openPrintDialog = action('openPrintDialog', (surfaceStore: CalendarSurfaceStore) =>
    addDatapointConfig(
        {
            name: 'PrintPreviewOpened',
        },
        {
            surfaceStore,
        }
    )
);
